import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button,
  CardContent, Divider, InputLabel, CardHeader, MenuItem, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { parseInt } from 'lodash';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import moment from 'moment';
import tokenDecoder from '../../../utils/tokenDecoder';
import { confirmAlert } from 'react-confirm-alert';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }

}));

var screenCode = "SUPPLIERRATECONFIGURATION"
export default function SupplierRateConfiguration(props) {
  const [title, setTitle] = useState("Supplier Rate Configuration");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const [saveButtonEnable, setSaveButtonEnable] = useState(false);
  const [isBalancePaymentCalculated, setIsBalancePaymentCalculated] = useState(false);
  const classes = useStyles();
  const [groups, setGroups] = useState()
  const [factories, setFactories] = useState()
  const [supplierRateConfigurationDetails, setSupplierRateConfigurationDetails] = useState([])
  const [searchStarted, setSearchStarted] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isMinEror, setIsMinEror] = useState({});
  const [minErrorMsg, setMinErrorMsg] = useState({});
  const [isValid, setIsValid] = useState(true);
  const [routes, setRoutes] = useState();
  const [uploadData, setUploadData] = useState([]);
  const [rateError, setRateError] = useState(false);
  const [transactionTypes, setTransactionTypes] = useState()
  const exceptThisSymbols = ["e", "E", "+", "-"];
  const [currentDate] = useState(new Date());
  
  const [supplierRateConfigurationData, setSupplierRateConfigurationData] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    transactionTypeID: 0,
    registrationNumber: ''
  });

  const navigate = useNavigate();
  const alert = useAlert();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  useEffect(() => {
    setSelectedDate(null)
    getPermissions();
    trackPromise(
      getGroupsForDropdown(), GetTransactionTypesForSupplierRateConfiguration()
    );
  }, []);

  useEffect(() => {
    setSelectedDate(null)
    getFactoriesForDropdown()
    setSupplierRateConfigurationDetails([])
  }, [supplierRateConfigurationData.groupID]);

  useEffect(() => {
    setSelectedDate(null)
    trackPromise(getAllRoutesForDropDown());
    setSupplierRateConfigurationDetails([])
  }, [supplierRateConfigurationData.factoryID]);

  useEffect(() => {
    setSelectedDate(null)
    setSupplierRateConfigurationDetails([])
  }, [supplierRateConfigurationData.routeID]);

  useEffect(() => {
    setSupplierRateConfigurationDetails([])
  }, [supplierRateConfigurationData.transactionTypeID, selectedDate]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERRATECONFIGURATION');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setSupplierRateConfigurationData({
      ...supplierRateConfigurationData,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(supplierRateConfigurationData.groupID);
    setFactories(factories);
  }

  async function getAllRoutesForDropDown() {
    const route = await services.getRoutesForDropDown(supplierRateConfigurationData.factoryID);
    setRoutes(route);
  }

  async function GetTransactionTypesForSupplierRateConfiguration() {
    const transactionTypes = await services.GetTransactionTypesForSupplierRateConfiguration();
    setTransactionTypes(transactionTypes);
  }

  async function GetSupplierRateConfigurationDetails() {
    const isBalancePaymentCalculated = await services.CheckBalancePaymentHasOccured(supplierRateConfigurationData.groupID, supplierRateConfigurationData.factoryID, moment(selectedDate).format('L'));
    if (isBalancePaymentCalculated){
      alert.error("Balance Payment has been completed for this month!");
    }
    setIsBalancePaymentCalculated(isBalancePaymentCalculated);

    const result = await services.GetSupplierRateConfigurationDetails(supplierRateConfigurationData.groupID,
      supplierRateConfigurationData.factoryID,
      supplierRateConfigurationData.routeID,
      supplierRateConfigurationData.transactionTypeID,
      transactionTypes[supplierRateConfigurationData.transactionTypeID].code,
      moment(selectedDate).format('L'),
      supplierRateConfigurationData.registrationNumber);

    const sortedData = [...result];
    sortedData.sort((a, b) => {
      return a.registrationNumber.localeCompare(b.registrationNumber, undefined, { numeric: true });

    });

    setSupplierRateConfigurationDetails(sortedData);
    setSearchStarted(true);
  }

  async function SaveSupplierRateConfigurationDetails() {

    var patternx = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;
    let array = supplierRateConfigurationDetails.filter(x => (x.rate != null) && (patternx.test(x.rate.toString())));

    var date = moment(selectedDate).format('L');
    var month = moment(date).format('MM');
    var year = moment(date).format('YYYY');

    setIsDisableButton(true);
    array.forEach(x => {
      x.groupID = parseInt(supplierRateConfigurationData.groupID);
      x.factoryID = parseInt(supplierRateConfigurationData.factoryID);
      x.routeID = parseInt(supplierRateConfigurationData.routeID);
      x.transactionTypeID = supplierRateConfigurationData.transactionTypeID;
      x.transactionTypeCode = transactionTypes[supplierRateConfigurationData.transactionTypeID].code;
      x.rate = parseFloat(x.rate).toFixed(2);
      x.createdBy = tokenDecoder.getUserIDFromToken();
      x.applicableMonth = month;
      x.applicableYear = year;
    });
    let response = await services.SaveSupplierRateConfigurationDetails(array);

    if (response.statusCode == "Success") {
      setSupplierRateConfigurationData({
        ...supplierRateConfigurationData,
        routeID: 0,
        transactionTypeID: 0,
        registrationNumber: ''
      });

      alert.success("Supplier Rate Configuration Saved Successfully");
      setIsDisableButton(false);
      setSaveButtonEnable(false);

    }
    else {
      alert.error("Error occured when save Supplier Rate Configuration ");
      setSupplierRateConfigurationData({
        ...supplierRateConfigurationData,
        routeID: 0,
        transactionTypeID: 0,
        registrationNumber: ''
      });
      alert.error("Error occured when save Supplier Rate Configuration ");
      setIsDisableButton(false);
      setSaveButtonEnable(false);
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
      }
    }
    return items
  }

  function generateDropDownMenuWithTwoValues(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setSupplierRateConfigurationData({
      ...supplierRateConfigurationData,
      [e.target.name]: value
    });
  }
  function handleDateChange(date) {
var month = date.getUTCMonth() + 1;
  var year = date.getUTCFullYear();
  
  var currentMonth = currentDate.getUTCMonth() + 1;
  var currentYear = currentDate.getUTCFullYear();

  if (year < currentYear || (year === currentYear && month <= currentMonth)) {
    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1;
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date);
        setIsValid(true);
        setMinErrorMsg({});
        setIsMinEror({});
      }
    } else {
      setSelectedDate(date);
    }
  } else {
    alert.error("You cannot select future months.");
  }
}

  function handleRateChange(e, customerAccountID) {

    const target = e.target;
    let value = target.value

    let decimalPart = value.split('.')[1];
    if (decimalPart == undefined) {
      decimalPart = "1";
    }
    if (decimalPart.length <= 2) {
      const newArr = [...supplierRateConfigurationDetails];
      var idx = newArr.findIndex(e => e.customerAccountID == parseInt(customerAccountID));
      checkMinValue(value, idx)
      newArr[idx] = { ...newArr[idx], rate: parseFloat(value) };
      setSaveButtonEnable(true)
      setSupplierRateConfigurationDetails(newArr);
    }

  }

  function checkMinValue(value, id) {
    var pattern = /^-?\d+(\.\d{0,2})?$/;
    setIsValid(false);

    var copyOfMinErrMsgs = minErrorMsg;
    var copyOfIsMinEror = isMinEror;
    copyOfIsMinEror[id] = id;
    setIsMinEror(copyOfIsMinEror);

    if (!pattern.test(value.toString())) {
      copyOfMinErrMsgs[id] = "Rate only allow numbers.";
      setIsDisableButton(true)
    } else if (value < 0) {
      copyOfMinErrMsgs[id] = "Rate need to be a positive number.";
      setIsDisableButton(true)
    } else {
      copyOfMinErrMsgs[id] = "";
      setIsDisableButton(false)
      setIsValid(true);
      copyOfIsMinEror[id] = -1;
      setIsMinEror(copyOfIsMinEror);
    }

    setMinErrorMsg(copyOfMinErrMsgs);
  }

  async function ConfirmSave() {

    confirmAlert({
      title: 'Confirm Save',
      message: 'Are you sure you want to save these rates?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => trackPromise(SaveSupplierRateConfigurationDetails())
        },
        {
          label: 'No',
          onClick: () => handleClose()
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });

  }

  const handleClose = () => {
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>

      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: supplierRateConfigurationData.groupID,
              factoryID: supplierRateConfigurationData.factoryID,
              routeID: supplierRateConfigurationData.routeID,
              transactionTypeID: supplierRateConfigurationData.transactionTypeID,
              registrationNumber: supplierRateConfigurationData.registrationNumber,
              selectedDate: selectedDate
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
                routeID: Yup.number().required('Route is required').min("1", 'Route is required'),
                transactionTypeID: Yup.number().required('Transaction Type is required').min("1", 'Transaction Type is required'),
                selectedDate: Yup.string().required('Select applicable month').nullable()
              })
            }
            onSubmit={() => trackPromise(GetSupplierRateConfigurationDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              props
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={supplierRateConfigurationData.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={supplierRateConfigurationData.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">
                              Route *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.routeID && errors.routeID)}
                              fullWidth
                              helperText={touched.routeID && errors.routeID}
                              size='small'
                              name="routeID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={supplierRateConfigurationData.routeID}
                              id="routeID"
                              variant="outlined"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              error={Boolean(
                                touched.selectedDate && errors.selectedDate
                              )}
                              helperText={
                                touched.selectedDate && errors.selectedDate
                              }
                              autoOk
                              variant="inline"
                              openTo="month"
                              views={["year", "month"]}
                              label="Year and Month *"
                              value={selectedDate}
                              onChange={(date) => handleDateChange(date)}
                              size='small'
                              maxDate={new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)}
                              disablePast={false}
                              disableFuture={true}
                            />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="transactionTypeID">
                              Transaction Type *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.transactionTypeID && errors.transactionTypeID)}
                              fullWidth
                              helperText={touched.transactionTypeID && errors.transactionTypeID}
                              name="transactionTypeID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={supplierRateConfigurationData.transactionTypeID}
                              variant="outlined"
                              id="transactionTypeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Transaction Type--</MenuItem>
                              {generateDropDownMenuWithTwoValues(transactionTypes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.registrationNumber && errors.registrationNumber)}
                              fullWidth
                              helperText={touched.registrationNumber && errors.registrationNumber}
                              size='small'
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={supplierRateConfigurationData.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                            >
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            disabled={isSubmitting || isDisableButton}
                            type="submit"
                            variant="contained"
                          >
                            {"Search"}
                          </Button>
                        </Box>
                        {(supplierRateConfigurationDetails.length > 0) ?
                          <Grid item md={12} xs={12}>
                            <Grid className={classes.container}>
                              <Collapse in={true}>
                                <Paper elevation={0} className={classes.paper}>
                                  <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                      <TableContainer >
                                        <Table className={classes.table} aria-label="caption table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align={'left'}>Registration Number</TableCell>
                                              <TableCell align={'left'}>Customer Name</TableCell>
                                              <TableCell align={'center'}>Rate</TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {supplierRateConfigurationDetails.map((data, index) => (
                                              <TableRow key={index}>
                                                <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                  {data.registrationNumber}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                  {data.customerName}
                                                </TableCell>
                                                <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                  <Grid alignContent={'center'}  >

                                                    <TextField
                                                      error={rateError}
                                                      helperText={rateError}
                                                      name="Rate"
                                                      onBlur={handleBlur}
                                                      alignContent='center'
                                                      onChange={(e) => handleRateChange(e, data.customerAccountID, "minRate")}
                                                      value={(data.rate == null) ? '' : data.rate}
                                                      type='number'
                                                      variant="outlined"
                                                      size='small'
                                                      inputProps={{ style: { textAlign: 'center' } }}
                                                      onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                                      disabled={isBalancePaymentCalculated}
                                                    />
                                                  </Grid>
                                                  {(parseInt(isMinEror[index]) === parseInt(index)) ?
                                                    <small style={{ color: 'red', wordWrap: 'break-word' }}>{minErrorMsg[index]}</small> : null
                                                  }
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Grid>

                                  </Grid>
                                </Paper>
                              </Collapse>
                            </Grid>
                          </Grid>
                          :
                          <Box paddingTop="20px"
                            hidden={!searchStarted}
                            style={{ fontSize: '20px' }} >
                            {"- No records to display -"}
                          </Box>

                        }
                        {supplierRateConfigurationDetails.length > 0 ?
                          <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                              color="primary"
                              disabled={!saveButtonEnable || isDisableButton || isBalancePaymentCalculated}
                              type="button"
                              variant="contained"
                              onClick={() => ConfirmSave()}
                            >
                              {"Save"}
                            </Button>
                          </Box>
                          : null}
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
};
